module.exports = __webpack_public_path__ + "img/44.b0f285b5.gif";